import { LegalLinks } from '@updatecore/legal';
import '@updatecore/assets/fonts/bricolage_grotesque.css';
import '@updatecore/assets/fonts/dm_sans.css';
import logo_dark from '@updatecore/assets/logos/logo_dark.svg';
import { resolve_locale } from '../i18n/welcome_translations';
import './welcome.css';
import type { ReactNode } from 'react';

/**
 * Branded shell for the customer-facing /welcome routes ("dark premium
 * athletic"). Renders the atmospheric background, grain, brand lockup, and a
 * hero title, then the route's content. All effects are CSP-safe (scoped
 * under `.uf-stage`, self-hosted fonts).
 *
 * @param title - Hero heading for the panel.
 * @param children - Panel body (lead text, form, actions).
 */
export function AuthCard({
  title,
  children,
}: {
  title: ReactNode;
  children: ReactNode;
}): ReactNode {
  return (
    <main className="uf-stage">
      <div className="uf-bg" aria-hidden="true" />
      <div className="uf-grain" aria-hidden="true" />
      <section className="uf-card uf-stagger">
        <img className="uf-logo" src={logo_dark} alt="update Fitness" />
        <h1 className="uf-title">{title}</h1>
        {children}
        <LegalLinks
          language={resolve_locale(window.location.search)}
          className="uf-legal"
          link_class_name="uf-legal__link"
          aria_label="Rechtliches"
        />
      </section>
    </main>
  );
}
